import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { useFormValidationErrorsNotification } from '../../../../../Form'
import {
  REQUEST_FORM_FIELD_NAME_MANAGER,
  REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR,
  REQUEST_FORM_MANAGERS_FIELD_MAX_ITEMS,
} from '../../../RequestForm.constants'
import { isRequestFormManagersFieldMaxError } from '../../../RequestForm.utils'

export function useRequestFormFieldsValidation({
  entityActionError,
  filesError,
  filesUploading,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  useFormValidationErrorsNotification({
    entityActionError,
    files: { filesError, filesUploading },
    onRemoveNotification,
    onSetNotification,
  })

  useEffect(() => {
    if (
      isRequestFormManagersFieldMaxError(
        errors[REQUEST_FORM_FIELD_NAME_MANAGER]
      )
    ) {
      onSetNotification({
        id: REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR,
        text: t('Error.RequestManagersLimitExceeded', {
          limit: REQUEST_FORM_MANAGERS_FIELD_MAX_ITEMS,
        }),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR)
    }
  }, [errors])
}
